export default "__VITE_ASSET__685f8d57__"